const en = {
  nav_about: 'About',
  nav_packages: 'Packages',
  nav_calculator: 'Calculator',
  nav_contacts: 'Contacts',
  nav_start: 'Start Investing',

  hero_badge: 'Seasonal Trend · Spring 2025',
  hero_title_1: 'Spring growth of',
  hero_title_wheat: 'wheat',
  hero_title_2: '— double, triple or',
  hero_title_3: 'quadruple',
  hero_title_4: 'your money',
  hero_x2_label: '×2 profit',
  hero_x2_from: 'from €21,100',
  hero_x3_label: '×3 profit',
  hero_x3_from: 'from €26,000',
  hero_x4_label: '×4 profit',
  hero_x4_from: 'from €31,000',
  hero_desc: 'Historically, wheat prices surge in spring due to increased global demand, sowing season pressure, and depleting winter stocks. Investors use this seasonal cycle every year to multiply their capital.',
  hero_cta_calc: 'Calculate profit now',
  hero_cta_packages: 'View packages',
  hero_stat1_val: '+42%',
  hero_stat1_label: 'Average spring growth',
  hero_stat2_val: '5+ years',
  hero_stat2_label: 'Stable trend',
  hero_stat3_val: 'TOP-1',
  hero_stat3_label: 'World ag asset',
  hero_chart_title: 'Wheat Price Dynamics · Spring',
  hero_chart_sub: 'Indexed growth (Feb = 100%)',
  hero_chart_avg: '+42% avg',
  hero_chart_max: '+56%',
  hero_chart_max_label: 'Maximum seasonal growth',
  hero_chart_100: '100%',
  hero_chart_100_label: 'Years with positive growth',
  hero_scroll: 'scroll down',

  why_badge: 'Seasonal Analytics',
  why_title_1: 'Why does wheat',
  why_title_2: 'grow in spring?',
  why_subtitle: 'Five key factors forming a stable price trend every year',
  why_f1_title: 'Livestock Demand',
  why_f1_desc: 'In spring, demand for wheat-based feed increases sharply from livestock enterprises preparing for the active season.',
  why_f1_stat: '+21%',
  why_f1_label: 'demand growth',
  why_f2_title: 'Sowing Campaign',
  why_f2_desc: 'The beginning of the active spring sowing period creates market hype and pressure on available wheat stocks.',
  why_f2_stat: '+28%',
  why_f2_label: 'activity growth',
  why_f3_title: 'Food Producers',
  why_f3_desc: 'Bakeries and food manufacturers increase wheat purchases ahead of the summer production season.',
  why_f3_stat: '+19%',
  why_f3_label: 'purchase growth',
  why_f4_title: 'Stock Depletion',
  why_f4_desc: "By spring, last year's wheat stocks are critically low, creating a supply shortage that drives prices up.",
  why_f4_stat: '-35%',
  why_f4_label: 'stock remaining',
  why_f5_title: 'Market Expectations',
  why_f5_desc: 'The market prices in uncertainty about the upcoming harvest — this increases volatility and growth potential.',
  why_f5_stat: '+33%',
  why_f5_label: 'volatility growth',
  why_stat1_val: '+42%',
  why_stat1_label: 'Average growth over 5 years',
  why_text: 'According to statistics from past years, the spring season is one of the most active growth periods for',
  why_wheat: 'Wheat',
  why_disclaimer: 'Historical data CME Group, USDA · not financial advice',
  why_stat2_val: '100%',
  why_stat2_label: 'Years with growth (5/5)',

  pkg_badge: 'Investment Contracts',
  pkg_title_1: 'Choose your',
  pkg_title_2: 'investment',
  pkg_title_3: 'contract',
  pkg_subtitle: 'Three levels of participation — double, triple or quadruple your capital',
  pkg_investment: 'Investment',
  pkg_term: 'Term',
  pkg_term_val: '2 days',
  pkg_yield: 'Yield',
  pkg_profit_label: 'Net profit in 2 days',
  pkg_invested: 'Invested:',
  pkg_total: 'Total back:',
  pkg_btn: 'Start Investing',
  pkg_disclaimer: '* All yield data is based on historical market dynamics. Investments involve risks.',
  pkg_popular: 'Popular',
  pkg_maximum: 'Maximum',
  pkg_p1_name: 'Start Contract',
  pkg_p1_sub: 'Wheat Investments · 2 days',
  pkg_p1_f1: 'Entry threshold — €21,100',
  pkg_p1_f2: 'Profit ×2 in 2 days',
  pkg_p1_f3: 'Monthly report',
  pkg_p1_f4: 'Support 5/7',
  pkg_p1_f5: 'Personal account',
  pkg_p2_name: 'Balance Contract',
  pkg_p2_sub: 'Wheat Investments · 2 days',
  pkg_p2_f1: 'Entry threshold — €26,000',
  pkg_p2_f2: 'Profit ×3 in 2 days',
  pkg_p2_f3: 'Weekly report',
  pkg_p2_f4: 'Priority support',
  pkg_p2_f5: 'Personal account',
  pkg_p2_f6: 'Market analytics',
  pkg_p3_name: 'Premium Contract',
  pkg_p3_sub: 'Wheat Investments · 2 days',
  pkg_p3_f1: 'Entry threshold — €31,000',
  pkg_p3_f2: 'Profit ×4 in 2 days',
  pkg_p3_f3: 'Daily report',
  pkg_p3_f4: 'VIP support 7/7',
  pkg_p3_f5: 'Personal account',
  pkg_p3_f6: 'Market analytics',
  pkg_p3_f7: 'Personal manager',

  calc_badge: 'Yield Calculator',
  calc_title_1: 'Calculate',
  calc_title_2: 'your profit',
  calc_subtitle: 'Enter parameters and find out the expected income',
  calc_amount_label: 'Investment Amount',
  calc_package_label: 'Investment Package',
  calc_duration_label: 'Investment Duration',
  calc_duration_val: '2 days',
  calc_duration_note: 'Fixed term for all contracts',
  calc_result_title: 'Calculation Result',
  calc_multiplier: 'multiplier',
  calc_net_profit: 'Net Profit',
  calc_yield: 'yield / 2 days',
  calc_total: 'Total Amount Back',
  calc_invested_label: 'Investment',
  calc_package_row: 'Package',
  calc_period: 'Period',
  calc_period_val: '2 days',
  calc_bar_invested: 'Invested',
  calc_bar_profit: 'Profit',
  calc_choose_btn: 'Choose a Contract',

  act_badge: 'Investor Community',
  act_title_1: 'Thousands of investors already',
  act_title_2: 'earning with us',
  act_desc: "Every day our clients multiply their capital on wheat's seasonal spring trend. Join thousands of investors who use this cycle annually.",
  act_join: 'Join',
  act_view: 'View packages',
  act_stat1_val: '12 400+',
  act_stat1_label: 'Active Investors',
  act_stat2_val: '€28M+',
  act_stat2_label: 'Assets Under Management',
  act_stat3_val: '97%',
  act_stat3_label: 'Satisfied Clients',
  act_live_title: 'Platform Activity',
  act_live_note: 'real-time demonstration of platform user activity',
  act_invested: 'invested',
  act_earned: 'earned profit',
  act_now: 'now',

  trust_badge: 'Why They Trust Us',
  trust_title_1: 'Reliability proven by',
  trust_title_2: 'time',
  trust_subtitle: 'Wheat is the most liquid and predictable agricultural asset in the world',
  trust_c1_title: 'Oldest Trading Instrument',
  trust_c1_desc: 'Wheat is one of the oldest traded commodities in human history — a proven seasonal investment instrument for centuries.',
  trust_c2_title: 'TOP-1 World Ag Asset',
  trust_c2_desc: 'Wheat is the #1 global agricultural asset by trading volume and liquidity on CME and CBOT exchanges worldwide.',
  trust_c3_title: 'Increased Spring Volatility',
  trust_c3_desc: 'The spring season historically shows the highest volatility and growth potential, creating unique profit opportunities.',
  trust_s1_val: '200+',
  trust_s1_label: 'years of market history',
  trust_s2_val: '€120B+',
  trust_s2_label: 'annual trading volume',
  trust_s3_val: '#1',
  trust_s3_label: 'global ag asset',
  trust_s4_val: '99%',
  trust_s4_label: 'position liquidity',
  trust_cta_text: 'Ready to take advantage of the spring wheat trend? Calculate your potential profit right now.',
  trust_cta_btn: 'Calculate profit now',

  footer_tagline: '— Seasonal Wheat Investments',
  footer_copy: '© 2025 WheatVest. Not investment advice.',

  toast_invested: 'invested',
  toast_earned: 'earned profit',
};

export default en;
